module.exports = __webpack_public_path__ + "static/img/200090.e582f118.png";